<script setup lang="ts">
import { useUiStore } from '../../stores/uiStore'

const uiStore = useUiStore()
</script>

<template>
  <Dialog
    v-model:visible="uiStore.showConcurrencyDialog"
    modal
    header="Action Blocked"
    :style="{ width: '25rem' }"
    :closable="true"
  >
    <div class="flex flex-col items-center text-center py-4">
      <div class="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center mb-6">
        <i class="pi pi-users text-amber-500" style="font-size: 2.5rem"></i>
      </div>

      <h2 class="text-lg font-bold text-slate-900 mb-2">Multiple Users Active</h2>
      <p class="text-sm text-slate-600 mb-6 leading-relaxed">
        {{ uiStore.concurrencyMessage }}
      </p>

      <div class="w-full space-y-3">
        <Button
          v-if="uiStore.onRefresh"
          label="Refresh Data"
          severity="primary"
          class="w-full py-3 font-bold"
          @click="uiStore.handleRefresh()"
        />
        <Button
          :label="uiStore.onRefresh ? 'Dismiss' : 'Got it'"
          :severity="uiStore.onRefresh ? 'secondary' : 'primary'"
          :text="!!uiStore.onRefresh"
          class="w-full py-3 font-bold"
          @click="uiStore.showConcurrencyDialog = false"
        />
      </div>
    </div>
  </Dialog>
</template>
